import { selectors } from 'data'
import { useSelector } from 'react-redux'
import useScript from 'utils/useScript'

const getDDEnv = (env: Environment) => {
  if (env === 'dev') return 'dev'
  if (env === 'staging') return 'staging'
  if (env === 'prod' || env === 'prod-beta') return 'prod'
  return env
}

const DataDogTracker = () => {
  const config = useSelector(selectors.config.getConfig)
  const url = config.datadog ? 'https://www.datadoghq-browser-agent.com/datadog-rum-v4.js' : ''
  useScript(url, () => {
    try {
      window.DD_RUM.onReady(() => {
        window.DD_RUM.init({
          allowedTracingOrigins: [
            'https://api.dev.blockchain.info',
            'https://api.staging.blockchain.info',
            'https://api.blockchain.info',
            'https://api.blockchain.com'
          ],
          applicationId: config.datadog?.applicationId,
          beforeSend: (event) => {
            // remove jwt and csrf from view and resource urls
            event.view.url = event.view.url
              .replace(/jwt=[^&]*/, 'jwt=REDACTED')
              .replace(/csrf=[^&]*/, 'csrf=REDACTED')
            if (event.resource) {
              event.resource.url = event.resource.url
                .replace(/jwt=[^&]*/, 'jwt=REDACTED')
                .replace(/csrf=[^&]*/, 'csrf=REDACTED')
            }
          },
          clientToken: config.datadog?.clientToken,
          env: getDDEnv(config.env),
          sampleRate: config.datadog?.sampleRate ?? 100, // https://docs.datadoghq.com/real_user_monitoring/guide/sampling-browser-plans/
          service: 'mercury-frontend',
          site: config.datadog?.site ?? 'datadoghq.eu',
          trackInteractions: true,
          version: APP_VERSION
        })
      })
    } catch (e) {}
  })
  return null
}

export default DataDogTracker
